import React from 'react';
import styled from 'styled-components';
import { EmptyState } from '@teals/ui-web';

const PageBody = styled.div`
  padding: 2rem 0 4rem;
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const PageHeader = styled.div`
  margin-bottom: 2rem;

  h1 {
    font-size: 1.5rem;
    margin-bottom: 0.25rem;
  }

  p {
    font-size: 0.875rem;
    color: var(--text-muted);
  }
`;

const Apps: React.FC = () => (
  <PageBody className="fade-in">
    <Container>
      <PageHeader>
        <h1>Apps</h1>
        <p>Build and publish standalone applications using agents and integrations</p>
      </PageHeader>

      <EmptyState
        title="Apps coming soon"
        description="Build standalone applications powered by your agents and integrations. Each app gets a unique URL and can be published as a web or mobile application."
      />
    </Container>
  </PageBody>
);

export default Apps;
